import { render, staticRenderFns } from "./CustomerCreateFormWizard.vue?vue&type=template&id=200be9d2&"
import script from "./CustomerCreateFormWizard.vue?vue&type=script&lang=ts&"
export * from "./CustomerCreateFormWizard.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerCreateFormWizard.vue?vue&type=style&index=0&id=200be9d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports